<template>
  <div>
    <h2>Scheduled Items</h2>
    <v-card>
      <v-data-table
        :items='this.scheduledServices'
        :headers='headers'
        :loading="$wait.is(['loading services'])"
        :footer-props.sync='footerProps'
        :options.sync='options'
        :server-items-length='serverCount'
        :items-per-page='options.itemsPerPage'
      >
        <v-progress-linear v-slot:progress color='blue' indeterminate></v-progress-linear>
        <template v-slot:item='props'>
          <tr @click='!disabled ? $router.push({ query: { serviceId: props.item.id } }) : null'>
            <td>
              {{ props.item.date | formatDate }}
              <div v-if='props.item.manuallyMoved' class='caption'>(Manually Moved)</div>
            </td>
            <tasks-chip-list v-model='props.item.tasks' show-due-at show-due-at-tolerance documents-enabled></tasks-chip-list>
          </tr>
        </template>
        <template v-slot:no-results>
          <v-layout row align-center>
            <v-flex>No service history found</v-flex>
          </v-layout>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import Services from '@/components/Services/ServicesClient.vue';
import TasksChipList from '@/components/ServiceTasks/ChipList.vue';
import GarageLocationsClient from '@/components/GarageLocations/GarageLocationsClient.vue';
import { Event } from '@/plugins/bus';

export default {
  components: {
    TasksChipList
  },
  props: {
    unit: {
      required: true
    }
  },
  mixins: [GarageLocationsClient, Services],
  data() {
    return {
      scheduledServices: [],
      serverCount: 0,
      options: {
        itemsPerPage: 10,
        sortBy: ['name']
      },
      footerProps: {
        itemsPerPageOptions: [10, 50, 100]
      },
      headers: [{ text: 'Date', value: 'date', sortable: false }, { text: 'Tasks', value: 'tasks', sortable: false }],
      model: {}
    };
  },
  computed: {
    unitId() {
      return this.$route.params.unitId;
    },
    disabled() {
      const g = this.unit.garageLocationId;
      return !this.userIsWorkshopManagerInGarage(g, this.userGarages) && !this.userIsDataEntryInGarage(g, this.userGarages) && !this.userIsFleetManager;
    },
    params() {
      return {
        pageSize: this.options && this.options.itemsPerPage,
        page: this.options && this.options.page,
        completed: false,
        orderBy: 'date',
        unitId: this.unitId
      };
    }
  },
  methods: {
    async loadServices() {
      let results = await this.getUnitServices(this.unitId);
      this.scheduledServices = results ? this.sortServicesAndTasks(results.data) : [];
      this.serverCount = results ? results.total : 0;
    }
  },
  async mounted() {
    this.loadServices();
    this.$bus.$on(Event.ServiceCompleted, this.loadServices);
    this.$bus.$on(Event.DocumentsUpdated, this.loadServices);
    this.$bus.$on(Event.UnitUpdated, this.loadServices);
  },
  destroyed() {
    this.$bus.$off(Event.ServiceCompleted, this.loadServices);
    this.$bus.$off(Event.DocumentsUpdated, this.loadServices);
    this.$bus.$off(Event.UnitUpdated, this.loadServices);
  },
  watch: {
    async unitId(val) {
      this.loadServices();
    },
    options: {
      async handler() {
        await this.loadServices();
      },
      deep: true
    }
  }
};
</script>
<style>
.disabled {
  cursor: not-allowed;
}

td {
  cursor: pointer;
}
</style>
